import React from 'react';

import { FormattedMessage } from 'react-intl-next';

import { IconButton } from '@atlaskit/button/new';
import ChevronLeft from '@atlaskit/icon/core/chevron-left';
import CrossIcon from '@atlaskit/icon/core/cross';
import Lozenge from '@atlaskit/lozenge';
import AkModalDialog, { ModalBody, ModalHeader } from '@atlaskit/modal-dialog';
import { Flex, Text } from '@atlaskit/primitives/compiled';
import { type ConversationAssistantConfig } from '@atlassian/conversation-assistant';

import messages from './messages';
import { StagingArea } from './staging-area';
import { FinalizeActionButton } from './staging-area/finalize-action-button';
import { SmartCreateIcon } from './staging-area/smart-create-icon';

type SmartCreationModalProps = {
	spaceKey: string;
	config: ConversationAssistantConfig;
	headerIcon: React.ReactNode;
	handleClose: () => void;
	handlePrevious: () => void;
	title: string;
	contentId: string;
};

export const SmartCreationModal = ({
	config,
	handleClose,
	handlePrevious,
	headerIcon,
	title,
	spaceKey,
	contentId,
}: SmartCreationModalProps) => {
	return (
		<AkModalDialog width="100%">
			<ModalHeader>
				<Flex alignItems="center" gap="space.100">
					<IconButton icon={ChevronLeft} label="Go back" shape="circle" onClick={handlePrevious} />
					<SmartCreateIcon contentType="livedoc" />
					<Text size="medium">Page Title</Text>
					<Lozenge appearance="default">
						<FormattedMessage {...messages.previewLozenge} />
					</Lozenge>
				</Flex>
				<Flex alignItems="center" gap="space.200">
					<FinalizeActionButton />
					<IconButton icon={CrossIcon} label="Close" shape="circle" onClick={handleClose} />
				</Flex>
			</ModalHeader>
			<ModalBody>
				<StagingArea config={config} spaceKey={spaceKey} contentId={contentId} />
			</ModalBody>
		</AkModalDialog>
	);
};
